import { useId } from 'react';
import { Button } from 'react-aria-components';
import { Loader2 } from 'lucide-react';
import { useT } from '../../../i18n/hooks';
import { FM } from './messages';
import { cx } from './parts';
import type { FormActionsProps } from './types';
import './styles';

/**
 * Ряд кнопок формы: основная справа, вторичная левее, причина выключенной
 * основной — слева текстом (`note`). Выключенная кнопка без причины — тупик:
 * человек не знает, чего не хватает. `sticky` — липкий низ страницы (мастер).
 * Внутри `FormDialog` встаёт в футер окна. `primary.tone: 'danger'` — основная
 * кнопка необратимого действия (красный тон, текст кнопки называет действие).
 */
export function FormActions({ primary, secondary, note, sticky = false, className }: FormActionsProps) {
  const t = useT();
  const noteId = useId();
  const PrimaryIcon = primary.icon;
  return (
    <div className={cx('fm-actions', className)} data-sticky={sticky ? '' : undefined}>
      {note ? (
        <div id={noteId} className="fm-actions__note" aria-live="polite">
          {note}
        </div>
      ) : null}
      <div className="fm-actions__buttons">
        {secondary ? (
          <Button className="btn btn--ghost focus-ring" onPress={secondary.onPress}>
            {secondary.label}
          </Button>
        ) : null}
        <Button
          className={`btn ${primary.tone === 'danger' ? 'btn--danger' : 'btn--primary'} focus-ring`}
          type={primary.type ?? 'button'}
          // `isPending` — не «выключена»: кнопка остаётся в порядке обхода и объявляет ожидание,
          // а повторное нажатие не проходит (двойная отправка формы).
          isPending={primary.isPending}
          isDisabled={primary.isDisabled}
          onPress={primary.onPress}
          aria-describedby={note && primary.isDisabled ? noteId : undefined}
        >
          {primary.isPending ? <Loader2 size={18} className="fm-spin" aria-label={t(FM.pending)} /> : PrimaryIcon ? <PrimaryIcon size={18} aria-hidden /> : null}
          {primary.label}
        </Button>
      </div>
    </div>
  );
}
